import React from 'react'
import { css } from '@emotion/core'
import { Skeleton, useContainerWidth } from '@fs/zion-ui'

const divCss = css`
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  padding: 6em 1.5em;
  gap: 2rem;
  @media (max-width: 500px) {
    flex-direction: column;
    padding: 0.5em;
  }
`
const WhatIsGetInvolvedSkeleton = () => {
  // Initiate state variables and hooks
  const atWidth = useContainerWidth()

  return (
    <div css={divCss} data-testid="WhatIsGetInvolvedSkeleton">
      <Skeleton.H1 />
      <Skeleton.Image
        height={atWidth({
          default: 150,
          sm: 200,
          md: 400,
        })}
      />
    </div>
  )
}

export default WhatIsGetInvolvedSkeleton
